export default function Django_Tutorial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Django_Tutorial</h1>
      <p>Content for Django_Tutorial goes here.</p>
    </div>
  );
}